import Contact from '../../../weon/models/Contact';

const state = {
  contact: new Contact(),
  contactLatestChurnRisk: null,
  contactColumns: [],
  history: {},
  paramsHistory: {},
  contactsFound: {},
  summaryDialog: false,
  contactDetails: null,
  originalHistoryFromContact: null,
  historyFromContact: null,
  fieldsContactCategory: null,
  loadingHistory: false,
  contactFilterSelected: null,
  contactFilterType: null,
  contactTags: [],
};

export default state;
